import { filter, map, mapValues, pick } from 'lodash-es'

import { hasCoordinates } from '../helpers'

const LOCATION_PIN = 'location'
const LOCATION_DISABLED_PIN = 'locationDisabled'

const normalizeCoordinates = coordinates =>
  mapValues(pick(coordinates, ['latitude', 'longitude']), Number)

const createPinData = (location, isDisabled) => {
  const { id, position, name, googlePlaceId, coordinates } = location
  const { longitude, latitude } = normalizeCoordinates(coordinates)

  return {
    type: isDisabled ? LOCATION_DISABLED_PIN : LOCATION_PIN,
    properties: {
      cluster: false,
      index: position,
      locationId: id,
      title: name,
      description: googlePlaceId,
    },
    geometry: {
      type: 'Point',
      coordinates: [longitude, latitude],
    },
  }
}

const createPinDataFromLocations = (locations, isDisabled) =>
  map(
    filter(locations, ({ coordinates }) => hasCoordinates(coordinates)),
    location => createPinData(location, isDisabled),
  )

export default createPinDataFromLocations
